var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E3E3E3",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5875 12.4375H14.0125C13.5948 12.4375 13.1942 12.6034 12.8988 12.8988C12.6034 13.1942 12.4375 13.5948 12.4375 14.0125V23.4625C12.4375 23.8802 12.6034 24.2808 12.8988 24.5762C13.1942 24.8716 13.5948 25.0375 14.0125 25.0375H21.8875C22.3052 25.0375 22.7058 24.8716 23.0012 24.5762C23.2966 24.2808 23.4625 23.8802 23.4625 23.4625V14.0125C23.4625 13.5948 23.2966 13.1942 23.0012 12.8988C22.7058 12.6034 22.3052 12.4375 21.8875 12.4375H20.3125",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7359 10.8623H17.1609C16.2911 10.8623 15.5859 11.5675 15.5859 12.4373C15.5859 13.3072 16.2911 14.0123 17.1609 14.0123H18.7359C19.6058 14.0123 20.3109 13.3072 20.3109 12.4373C20.3109 11.5675 19.6058 10.8623 18.7359 10.8623Z",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 17.9502H15.5936",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7383 17.9502H20.3133",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 21.0996H15.5936",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7383 21.0996H20.3133",
    stroke: "#312E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.0c656cce15ce8d21f0da2dec3370a4a6.svg";
export { ForwardRef as ReactComponent };